module.exports = __webpack_public_path__ + "static/img/3-5.19124a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/3-5.jpg
// module id = 3s3j
// module chunks = 25